import styles from 'components/contactForm/contactForm.module.css';
import { ProgressBar } from 'components/contactForm/progressBar/ProgressBar';
import {
    ISubmitButtonProps,
    SubmitButton,
} from 'components/contactForm/submitButton/SubmitButton';

export const ContactFormFooter = ({
    step,
    values,
    setStep,
    isSubmitting,
}: ISubmitButtonProps) => {
    return (
        <div className={styles.formProgress}>
            <ProgressBar step={step} />

            <SubmitButton
                step={step}
                values={values}
                setStep={setStep}
                isSubmitting={isSubmitting}
            />
        </div>
    );
};
